import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private api: ApiService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userType = localStorage.getItem('endUserType');
    const userId = localStorage.getItem('endUserId');
    const url = state.url;

    // If user is authenticated
    if (userType && userId) {
      // If at root path or trying to access auth pages while logged in, redirect to dashboard
      if (url === '/' || url.includes('/auth/')) {
        this.redirectToDashboard(userType);
        return false;
      }

      // Check if user has access to the requested module
      if (url.includes('/admin/') && userType !== 'admin') {
        this.redirectToDashboard(userType);
        return false;
      }
      if (url.includes('/specialist/') && userType !== 'specialist') {
        this.redirectToDashboard(userType);
        return false;
      }
      if (url.includes('/pcv/') && userType !== 'pcv' && userType !== 'vc') {
        this.redirectToDashboard(userType);
        return false;
      }

      return true;
    }
    
    // If not authenticated
    // Allow access to auth routes
    if (url.includes('/auth/')) {
      return true;
    }
    
    // Redirect to appropriate sign-in page based on route with returnUrl
    if (url.includes('/admin/')) {
      this.router.navigate(['/auth/admin-signin'], { queryParams: { returnUrl: url } });
    } else if (url.includes('/specialist/')) {
      this.router.navigate(['/auth/specialist-signin'], { queryParams: { returnUrl: url } });
    } else if (url.includes('/pcv/')) {
      this.router.navigate(['/auth/pcv-signin'], { queryParams: { returnUrl: url } });
    } else {
      this.router.navigate(['/auth/specialist-signin'], { queryParams: { returnUrl: url } });
    }
    return false;
  }

  private redirectToDashboard(userType: string): void {
    switch (userType) {
      case 'pcv':
      case 'vc':
        this.router.navigate(['/pcv/dashboard']);
        break;
      case 'specialist':
        this.router.navigate(['/specialist/dashboard']);
        break;
      case 'admin':
        this.router.navigate(['/admin/dashboard']);
        break;
      default:
        this.router.navigate(['/auth/sign-in']);
    }
  }
} 